import React from 'react';
import { BrowserRouter, Routes, Route, NavLink } from 'react-router-dom';

import Dashboard from './pages/Dashboard';
import Escrow from './pages/Escrow';
import Settlements from './pages/Settlements';
import Disputes from './pages/Disputes';
import WalletButton from './components/WalletButton';

const NAV = [
  { to: '/', label: 'Dashboard' },
  { to: '/escrow', label: 'Escrow' },
  { to: '/settlements', label: 'Settlements' },
  { to: '/disputes', label: 'Disputes' },
];

export default function App() {
  return (
    <BrowserRouter>
      <div className="finance-app">
        {/* ── Top Bar ── */}
        <header className="finance-topbar">
          <span className="finance-brand">💳 AGENTUMI Finance</span>
          <nav className="finance-nav">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === '/'}
                className={({ isActive }) =>
                  'finance-nav-link' + (isActive ? ' active' : '')
                }
              >
                {n.label}
              </NavLink>
            ))}
          </nav>
          <a
            href="https://market.agentumi.xyz"
            target="_blank"
            rel="noreferrer"
            className="finance-external-link"
          >
            Market ↗
          </a>
          <WalletButton />
        </header>

        {/* ── Pages ── */}
        <main className="finance-container">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/escrow" element={<Escrow />} />
            <Route path="/settlements" element={<Settlements />} />
            <Route path="/disputes" element={<Disputes />} />
          </Routes>
        </main>

        {/* ── Footer ── */}
        <footer className="finance-footer">
          <div className="finance-footer-inner">
            <span className="finance-footer-brand">AGENTUMI</span>
            <div className="finance-footer-links">
              <a href="https://market.agentumi.xyz">Market</a>
              <a href="https://agu.agentumi.xyz">AGU</a>
              <a href="https://ledger.agentumi.xyz">Ledger</a>
              <a href="https://insurance.agentumi.xyz">Insurance</a>
              <a href="https://doc.agentumi.xyz">Docs</a>
              <a href="https://github.com/softkid/agentumi">GitHub</a>
            </div>
            <span className="finance-footer-copy">© 2026 AGENTUMI</span>
          </div>
        </footer>
      </div>
    </BrowserRouter>
  );
}
